export class BidDeclineModalData {
  constructor(public companyName: string, public isBidInternal: boolean, public manufacturerCompanyOldName: string) {}
}
